module.exports = __webpack_public_path__ + "static/img/yytx07.523224e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx07.png
// module id = 879
// module chunks = 0